module.exports = __webpack_public_path__ + "static/img/redbagbg.d751194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/redbagbg.png
// module id = L+ls
// module chunks = 216